import { ref, watch, onBeforeUnmount } from "vue";
import { disableWindowScroll, enableWindowScroll } from "@spoferan/spoferan-ts-core";
export const FullScreenComponentEmits = ["update:fullscreen"];
export function useFullScreenComponent(fullScreenElement, props, emit = () => {
}) {
  const isFullScreen = ref(props.fullscreen);
  let initialStylesBeforeFullscreen = {};
  watch(isFullScreen, (newValue) => {
    if (newValue) {
      openFullScreen();
    } else {
      exitFullScreen();
    }
    emit("update:fullscreen", newValue);
  });
  watch(() => props.fullscreen, (newValue) => {
    isFullScreen.value = newValue;
  });
  onBeforeUnmount(() => {
    enableWindowScroll();
  });
  function openFullScreen() {
    const styles = {
      zIndex: 100,
      overflowY: "auto",
      overflowX: "hidden",
      width: window.innerWidth + "px",
      height: window.innerHeight + "px",
      position: "fixed",
      left: 0,
      top: 0,
      bottom: 0,
      right: 0
    };
    Object.keys(styles).forEach((styleKey) => {
      initialStylesBeforeFullscreen[styleKey] = fullScreenElement.value.style[styleKey];
      fullScreenElement.value.style[styleKey] = styles[styleKey];
    });
    disableWindowScroll();
  }
  function exitFullScreen() {
    Object.keys(initialStylesBeforeFullscreen).forEach((styleKey) => {
      fullScreenElement.value.style[styleKey] = initialStylesBeforeFullscreen[styleKey];
    });
    enableWindowScroll();
  }
  return {
    isFullScreen
  };
}
